import { Chart, RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

/**
 * レーダーチャートクラス
 * ゴルフ場の評価をレーダーチャートで表示
 */
/**
 * レーダーチャートクラス
 * ゴルフ場の評価をレーダーチャートで表示
 */
class RatingRadarChart {
    constructor(canvas) {
        this.canvas = canvas;
        this.ratings = this.extractRatings();
        this.chart = null;
        this.init();
    }

    /**
     * data属性から評価データを抽出
     */
    extractRatings() {
        return {
            staff: parseFloat(this.canvas.dataset.ratingStaff) || 0,
            facility: parseFloat(this.canvas.dataset.ratingFacility) || 0,
            meal: parseFloat(this.canvas.dataset.ratingMeal) || 0,
            course: parseFloat(this.canvas.dataset.ratingCourse) || 0,
            cost: parseFloat(this.canvas.dataset.ratingCost) || 0,
            distance: parseFloat(this.canvas.dataset.ratingDistance) || 0,
            fairway: parseFloat(this.canvas.dataset.ratingFairway) || 0,
        };
    }

    /**
     * チャートを初期化
     */
    init() {
        this.createChart();
    }

    /**
     * Chart.jsでレーダーチャートを作成
     */
    createChart() {
        const ctx = this.canvas.getContext('2d');

        // モバイル判定
        const isMobile = window.innerWidth < 768;

        // ラベルを超短縮版に（モバイル対応）
        // モバイルでは1-3文字の超短縮、PCでは読みやすい改行版
        const labels = [
            'スタッフ接客',
            '設備が充実',
            ['食事が', '美味しい'],
            ['コース/', '戦略性'],
            ['コスト', 'パフォーマンス'],
            '距離が長い',
            ['フェアウェイ', 'が広い']
        ];

        const data = [
            this.ratings.staff,
            this.ratings.facility,
            this.ratings.meal,
            this.ratings.course,
            this.ratings.cost,
            this.ratings.distance,
            this.ratings.fairway
        ];

        // 年齢層が高めのユーザー向けに、フォントサイズを設定
        // モバイルは超短縮ラベルなのでフォントを大きく、PCは改行対応で適切なサイズ
        const labelFontSize = isMobile ? 14 : 16;  // モバイル14px（短縮のため大きく）、PC16px
        const tickFontSize = isMobile ? 13 : 13;   // 数値は13pxで統一
        const labelPadding = isMobile ? 18 : 20;   // ラベルとチャートの間隔

        this.chart = new Chart(ctx, {
            type: 'radar',
            data: {
                labels: labels,
                datasets: [{
                    label: '評価',
                    data: data,
                    backgroundColor: 'rgba(16, 185, 129, 0.2)',
                    borderColor: 'rgba(16, 185, 129, 1)',
                    borderWidth: 2.5,  // 線を2→2.5に太く
                    pointBackgroundColor: 'rgba(16, 185, 129, 1)',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,               // 点の枠線を太く
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(16, 185, 129, 1)',
                    pointRadius: isMobile ? 3 : 5,     // PC時の点を4→5に拡大
                    pointHoverRadius: isMobile ? 5 : 7, // PC時のホバー点を6→7に拡大
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: isMobile ? 1.0 : 1.2,  // PCのアスペクト比を1.3→1.2に（より正方形に近く）
                layout: {
                    padding: {
                        top: isMobile ? 20 : 30,
                        bottom: isMobile ? 20 : 30,
                        left: isMobile ? 15 : 25,
                        right: isMobile ? 15 : 25
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        titleColor: '#fff',
                        bodyColor: '#fff',
                        borderColor: 'rgba(16, 185, 129, 1)',
                        borderWidth: 1,
                        padding: 12,
                        displayColors: false,
                        titleFont: {
                            size: 14,  // ツールチップタイトル拡大
                            weight: '600'
                        },
                        bodyFont: {
                            size: 14   // ツールチップ本文拡大
                        },
                        callbacks: {
                            label: function(context) {
                                return context.parsed.r.toFixed(1) + ' / 5.0';
                            }
                        }
                    }
                },
                scales: {
                    r: {
                        beginAtZero: true,
                        min: 0,
                        max: 5,
                        ticks: {
                            stepSize: 1,
                            font: {
                                size: tickFontSize,
                                family: "'Murecho', sans-serif"
                            },
                            color: '#6b7280',
                            backdropColor: 'transparent',
                            callback: function(value) {
                                return value.toFixed(0);
                            }
                        },
                        grid: {
                            color: '#e8eaef',  // グリッド線を濃く（グレー600の50%）
                            lineWidth: 1.5  // グリッド線を太く
                        },
                        // ラベル（評価項目名）の設定 - 見切れ防止と改行対応
                        pointLabels: {
                            font: {
                                size: labelFontSize,
                                weight: '600',  // フォントウェイトを600に（より太く）
                                family: "'Murecho', sans-serif",
                                lineHeight: 1.4  // 行間を調整（改行時の読みやすさ向上）
                            },
                            color: '#374151',
                            padding: labelPadding  // 見切れ防止のためpadding調整
                        },
                        angleLines: {
                            color: '#e8eaef',  // 角度線を濃く（グレー600の50%）
                            lineWidth: 1.5  // 角度線を太く
                        }
                    }
                },
                interaction: {
                    mode: 'nearest',
                    intersect: false
                }
            }
        });
    }

    /**
     * チャートを破棄
     */
    destroy() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }

    /**
     * チャートをリサイズ
     */
    resize() {
        if (this.chart) {
            this.chart.resize();
        }
    }
}

/**
 * 横棒グラフクラス
 * モバイル向けの詳細評価表示
 */
class RatingBarChart {
    constructor(container) {
        this.container = container;
        this.ratings = this.extractRatings();
        this.init();
    }

    /**
     * data属性から評価データを抽出
     */
    extractRatings() {
        return {
            staff: {
                value: parseFloat(this.container.dataset.ratingStaff) || 0,
                label: 'スタッフ接客'
            },
            facility: {
                value: parseFloat(this.container.dataset.ratingFacility) || 0,
                label: '設備が充実'
            },
            meal: {
                value: parseFloat(this.container.dataset.ratingMeal) || 0,
                label: '食事が美味しい'
            },
            course: {
                value: parseFloat(this.container.dataset.ratingCourse) || 0,
                label: 'コース/戦略性'
            },
            cost: {
                value: parseFloat(this.container.dataset.ratingCost) || 0,
                label: 'コストパフォーマンス'
            },
            distance: {
                value: parseFloat(this.container.dataset.ratingDistance) || 0,
                label: '距離が長い'
            },
            fairway: {
                value: parseFloat(this.container.dataset.ratingFairway) || 0,
                label: 'フェアウェイが広い'
            }
        };
    }

    /**
     * 横棒グラフを初期化
     */
    init() {
        this.createBarChart();
    }

    /**
     * 横棒グラフを作成
     */
    createBarChart() {
        const items = [
            this.ratings.staff,
            this.ratings.facility,
            this.ratings.meal,
            this.ratings.course,
            this.ratings.cost,
            this.ratings.distance,
            this.ratings.fairway
        ];

        items.forEach(item => {
            const barItem = this.createBarItem(item.label, item.value);
            this.container.appendChild(barItem);
        });
    }

    /**
     * 横棒アイテムを作成
     */
    createBarItem(label, value) {
        const percentage = (value / 5) * 100;

        // メインコンテナ
        const itemDiv = document.createElement('div');
        itemDiv.className = 'rating-bar-item';

        // ヘッダー部分
        const header = document.createElement('div');
        header.className = 'rating-bar-header';

        const labelSpan = document.createElement('span');
        labelSpan.className = 'rating-bar-label';
        labelSpan.textContent = label;

        const valueSpan = document.createElement('span');
        valueSpan.className = 'rating-bar-value';
        valueSpan.textContent = value.toFixed(1);

        header.appendChild(labelSpan);
        header.appendChild(valueSpan);

        // バーコンテナ部分
        const container = document.createElement('div');
        container.className = 'rating-bar-container';

        const fill = document.createElement('div');
        fill.className = 'rating-bar-fill';
        // インラインスタイル属性の代わりにstyleプロパティを使用（CSP対応）
        fill.style.width = `${percentage}%`;

        container.appendChild(fill);

        // 全体を組み立て
        itemDiv.appendChild(header);
        itemDiv.appendChild(container);

        return itemDiv;
    }
}

/**
 * ゴルフ場ギャラリークラス
 * 画像スライダー機能を提供
 */
class GolfCourseGallery {
    constructor(container) {
        this.container = container;
        this.galleryId = container.dataset.galleryId;
        this.slides = container.querySelectorAll('.gallery-slide');
        this.currentIndex = 0;
        this.indicators = [];
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.init();
    }

    init() {
        if (this.slides.length <= 1) {
            const prevBtn = this.container.querySelector('.gallery-prev');
            const nextBtn = this.container.querySelector('.gallery-next');
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            return;
        }

        this.setupIndicators();
        this.setupNavigation();
        this.setupTouchGestures();
        this.lazyLoadImages();
    }

    setupIndicators() {
        const indicatorsContainer = this.container.querySelector('.gallery-indicators');
        if (!indicatorsContainer) return;

        this.slides.forEach((_, index) => {
            const indicator = document.createElement('button');
            indicator.className = `w-2 h-2 rounded-full transition-all ${
                index === 0 ? 'bg-white w-6' : 'bg-white/50'
            }`;
            indicator.setAttribute('aria-label', `画像 ${index + 1}へ移動`);
            indicator.addEventListener('click', () => this.goToSlide(index));
            indicatorsContainer.appendChild(indicator);
            this.indicators.push(indicator);
        });
    }

    setupNavigation() {
        const prevBtn = this.container.querySelector('.gallery-prev');
        const nextBtn = this.container.querySelector('.gallery-next');

        if (prevBtn) {
            prevBtn.addEventListener('click', () => this.previousSlide());
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => this.nextSlide());
        }
    }

    setupTouchGestures() {
        this.container.addEventListener('touchstart', (e) => {
            this.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.container.addEventListener('touchend', (e) => {
            this.touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
        }, { passive: true });
    }

    handleSwipe() {
        const swipeThreshold = 50;
        const diff = this.touchStartX - this.touchEndX;

        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                this.nextSlide();
            } else {
                this.previousSlide();
            }
        }
    }

    lazyLoadImages() {
        const firstSlide = this.slides[0];
        if (firstSlide && firstSlide.dataset.lazySrc) {
            this.loadSlideImage(firstSlide);
        }

        if (this.slides[1] && this.slides[1].dataset.lazySrc) {
            this.loadSlideImage(this.slides[1]);
        }
    }

    loadSlideImage(slide) {
        const imageSrc = slide.dataset.lazySrc;
        if (!imageSrc) return;

        const img = new Image();
        img.src = imageSrc;
        img.alt = 'ゴルフ場の画像';

        const wrapper = document.createElement('div');
        wrapper.className = 'w-full h-48 flex items-center justify-center bg-gray-100';
        img.className = 'w-full h-full object-cover';
        img.style.maxHeight = '240px';

        img.onerror = function() {
            this.onerror = null;
            this.src = '/static/images/no-image.jpg';
        };

        img.onload = () => {
            wrapper.appendChild(img);
            slide.innerHTML = '';
            slide.appendChild(wrapper);
            slide.removeAttribute('data-lazy-src');
        };
    }

    goToSlide(index) {
        if (index < 0 || index >= this.slides.length) return;

        this.slides[this.currentIndex].classList.remove('active');
        if (this.indicators[this.currentIndex]) {
            this.indicators[this.currentIndex].classList.remove('bg-white', 'w-6');
            this.indicators[this.currentIndex].classList.add('bg-white/50');
        }

        this.currentIndex = index;

        this.slides[this.currentIndex].classList.add('active');
        if (this.indicators[this.currentIndex]) {
            this.indicators[this.currentIndex].classList.add('bg-white', 'w-6');
            this.indicators[this.currentIndex].classList.remove('bg-white/50');
        }

        if (this.currentIndex + 1 < this.slides.length) {
            const nextSlide = this.slides[this.currentIndex + 1];
            if (nextSlide.dataset.lazySrc) {
                this.loadSlideImage(nextSlide);
            }
        }
    }

    nextSlide() {
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(nextIndex);
    }

    previousSlide() {
        const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.goToSlide(prevIndex);
    }
}

/**
 * アコーディオンクラス
 * 情報の展開/折りたたみ機能を提供
 */
class Accordion {
    constructor(toggle) {
        this.toggle = toggle;
        this.targetId = toggle.dataset.accordionTarget;
        this.content = document.getElementById(this.targetId);
        this.icon = toggle.querySelector('.accordion-icon');
        this.isOpen = false;
        this.init();
    }

    init() {
        if (!this.content) return;

        this.toggle.addEventListener('click', () => this.toggleAccordion());
        this.toggle.setAttribute('aria-expanded', 'false');
        this.content.classList.add('hidden');
    }

    toggleAccordion() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.content.classList.remove('hidden');
        this.content.style.maxHeight = '0px';
        this.content.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            this.content.style.transition = 'max-height 0.3s ease-out';
            this.content.style.maxHeight = this.content.scrollHeight + 'px';
        });

        setTimeout(() => {
            this.content.style.maxHeight = 'none';
            this.content.style.overflow = 'visible';
        }, 300);

        if (this.icon) {
            this.icon.style.transform = 'rotate(180deg)';
        }
    }

    close() {
        this.isOpen = false;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.content.style.maxHeight = this.content.scrollHeight + 'px';
        this.content.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            this.content.style.transition = 'max-height 0.3s ease-out';
            this.content.style.maxHeight = '0px';
        });

        setTimeout(() => {
            this.content.classList.add('hidden');
            this.content.style.maxHeight = '';
            this.content.style.overflow = '';
        }, 300);

        if (this.icon) {
            this.icon.style.transform = 'rotate(0deg)';
        }
    }
}

/**
 * Mobile Menu Handler
 * モバイルメニューの開閉処理
 */
class MobileMenuHandler {
    constructor() {
        this.mobileMenuButton = null;
        this.mobileMenu = null;
        this.mobileMenuOverlay = null;
        this.mobileMenuClose = null;
        this.hamburgerIcon = null;
        this.closeIcon = null;

        this.init();
    }

    init() {
        // DOM要素の取得
        this.mobileMenuButton = document.getElementById('mobile-menu-button');
        this.mobileMenu = document.getElementById('mobile-menu');
        this.mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
        this.mobileMenuClose = document.getElementById('mobile-menu-close');
        this.hamburgerIcon = document.querySelector('.hamburger-icon');
        this.closeIcon = document.querySelector('.close-icon');

        // 必須要素が存在しない場合は初期化を中止
        if (!this.mobileMenuButton || !this.mobileMenu || !this.mobileMenuOverlay) {
            console.warn('Mobile menu elements not found');
            return;
        }

        // イベントリスナーの設定
        this.setupEventListeners();

        // 初期状態の設定
        this.closeMenu();
    }

    setupEventListeners() {
        // ハンバーガーボタンクリック
        this.mobileMenuButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleMenu();
        });

        // 閉じるボタンクリック
        if (this.mobileMenuClose) {
            this.mobileMenuClose.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.closeMenu();
            });
        }

        // オーバーレイクリックで閉じる
        this.mobileMenuOverlay.addEventListener('click', () => {
            this.closeMenu();
        });

        // メニュー内のリンククリックで閉じる
        const menuLinks = this.mobileMenu.querySelectorAll('a');
        menuLinks.forEach((link) => {
            link.addEventListener('click', () => {
                this.closeMenu();
            });
        });

        // Escキーで閉じる
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                const isExpanded = this.mobileMenuButton.getAttribute('aria-expanded') === 'true';
                if (isExpanded) {
                    this.closeMenu();
                }
            }
        });
    }

    toggleMenu() {
        const isExpanded = this.mobileMenuButton.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        console.log('Opening menu');
        this.mobileMenuButton.setAttribute('aria-expanded', 'true');

        // メニューを表示
        this.mobileMenu.style.transform = 'translateX(0)';

        // オーバーレイを表示
        this.mobileMenuOverlay.style.display = 'block';
        setTimeout(() => {
            this.mobileMenuOverlay.style.opacity = '1';
        }, 10);

        // スクロール防止
        document.body.classList.add('menu-open');
        document.body.style.overflow = 'hidden';

        // アイコン切り替え
        if (this.hamburgerIcon && this.closeIcon) {
            this.hamburgerIcon.style.display = 'none';
            this.closeIcon.style.display = 'block';
        }
    }

    closeMenu() {
        console.log('Closing menu');
        this.mobileMenuButton.setAttribute('aria-expanded', 'false');

        // メニューを非表示
        this.mobileMenu.style.transform = 'translateX(100%)';

        // オーバーレイを非表示
        this.mobileMenuOverlay.style.opacity = '0';
        setTimeout(() => {
            this.mobileMenuOverlay.style.display = 'none';
        }, 300);

        // スクロール復元
        document.body.classList.remove('menu-open');
        document.body.style.overflow = '';

        // アイコン切り替え
        if (this.hamburgerIcon && this.closeIcon) {
            this.hamburgerIcon.style.display = 'block';
            this.closeIcon.style.display = 'none';
        }
    }
}

// ====================================
// ホテル表示制御機能
// ====================================

/**
 * ホテルリストの「もっと見る」機能を管理するクラス
 */
class HotelShowMore {
    constructor(button) {
        this.button = button;
        this.container = button.closest('.mb-6').querySelector('.hotel-list-container');
        this.textElement = button.querySelector('.hotel-show-more-text');
        this.iconElement = button.querySelector('.hotel-show-more-icon');
        this.totalCount = parseInt(button.dataset.hotelCount) || 0;
        this.isExpanded = false;

        this.init();
    }

    init() {
        this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
        this.isExpanded = !this.isExpanded;

        if (this.isExpanded) {
            // すべて表示
            this.container.classList.add('hotel-show-all');
            this.textElement.textContent = '宿泊施設を閉じる';
        } else {
            // 3件のみ表示
            this.container.classList.remove('hotel-show-all');
            const remainingCount = this.totalCount - 3;
            this.textElement.textContent = `宿泊施設をもっと見る（残り${remainingCount}件）`;

            // スムーズにスクロールして最初のホテルセクションが見えるように
            const hotelSection = this.button.closest('.mb-6');
            if (hotelSection) {
                const headerOffset = 100; // ヘッダー分のオフセット
                const elementPosition = hotelSection.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }
}


// ========================================
// 初期化 (Initialization)
// ========================================
document.addEventListener('DOMContentLoaded', function() {
    // Lucide Icons初期化
    if (typeof lucide !== 'undefined' && lucide.createIcons) {
        lucide.createIcons();
    }

    // レーダーチャート初期化
    const radarCharts = [];
    const radarCanvases = document.querySelectorAll('.rating-radar-chart');
    radarCanvases.forEach(canvas => {
        const chart = new RatingRadarChart(canvas);
        radarCharts.push(chart);
    });

    // 横棒グラフ初期化（モバイル用詳細評価）
    const barChartContainers = document.querySelectorAll('.rating-bar-chart');
    barChartContainers.forEach(container => {
        new RatingBarChart(container);
    });

    // ウィンドウリサイズ時のチャート再描画（デバウンス処理）
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            radarCharts.forEach(chart => chart.resize());
        }, 250);
    });

    // ギャラリー初期化
    const galleries = document.querySelectorAll('.golf-course-gallery');
    galleries.forEach(gallery => {
        new GolfCourseGallery(gallery);
    });

    // アコーディオン初期化
    const accordionToggles = document.querySelectorAll('[data-accordion-target]');
    accordionToggles.forEach(toggle => {
        new Accordion(toggle);
    });

    // ホテル「もっと見る」ボタンの初期化
    const hotelShowMoreButtons = document.querySelectorAll('.hotel-show-more-btn');
    hotelShowMoreButtons.forEach(button => {
        new HotelShowMore(button);
    });

    // モバイルメニューの初期化
    new MobileMenuHandler();
});
